/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React from "react";

import { usePlayerComponents } from "../../../../../shared/context/PlayerComponentsContext";
import { usePlayerTranslation } from "../../../../../shared/context/PlayerTranslationContext";
import { useTimeCounterCallback } from "../../../../../shared/hooks/useTimeCounterCallback";
import PlayIcon from "../../../../../shared/icons/player/Play.svg";
import { usePlayerCurrentMedia } from "../../../../Controller";

import "./NextEpisode.scss";

interface NextEpisodeProps {
  timer: number;
}
export const NextEpisode = (props: NextEpisodeProps) => {
  const { timer } = props;

  const { loadNextMedia } = usePlayerCurrentMedia();

  const { Button } = usePlayerComponents();
  const { t } = usePlayerTranslation();

  const { percent } = useTimeCounterCallback(timer, loadNextMedia);

  return (
    <div className="NextEpisode">
      <Button variant="quaternary" progress={percent} onClick={loadNextMedia}>
        <PlayIcon aria-hidden="true" focusable="false" />
        {t("PLAYER_BUTTON_NEXT_EPISODE")}
      </Button>
    </div>
  );
};
